import React from 'react';
const Footer = () => {
    return ( 
        <div className="pt-5">
            <footer className="bg-secondary p-4">
                <div className="container">
                    <div className="d-flex justify-content-between">
                        <p className="m-0 font-weight-bold">Jean P. De la Cruz</p>
                        <p className="m-0">Todos los derechos reservados &copy;</p>
                    </div>
                </div>
            </footer>
        </div>
        
     );
}
 
export default Footer;